export default class CreateCategory {
  constructor (list) {
    if (list) {
      const btnCat = document.querySelectorAll('.editCategory')
      btnCat.forEach( (el) => {
        const input = el.parentNode.parentNode.querySelector('input[name="name"]')
        const form = input.parentNode
        form.addEventListener('submit', function (e) {
          e.preventDefault()
        })

        el.addEventListener('click', (e) => {
          e.preventDefault()
          input.classList.toggle('is-visible')
        })

        input.addEventListener('keyup', (e) => {
          if (e.keyCode === 13) {
            input.blur()
          }
        })

        input.addEventListener('blur', (e) => {
          e.preventDefault()
          const url = form.getAttribute('action')
          const token = form.querySelector('input[name="_token"]').value
          const id = form.querySelector('meta[name="id"]').getAttribute('content')
          const name = input.value
          this.blurFunction(name, url, id, token)
        })
      })
    }
  }
  blurFunction(name, url, id, token) {
    const http = new XMLHttpRequest()
    const params = 'name=' + name + '&' + 'id=' + id
    http.open('POST', '/admin/categories/edit', true)
    http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded; charset=UTF-8')
    http.setRequestHeader('X-CSRF-TOKEN', token)
    http.send(params)

    http.onreadystatechange = function (event) {
      if (this.readyState === XMLHttpRequest.DONE) {
        if (this.status === 200) {
          window.location.reload()
        } else {
          console.log('Status de la réponse: %d (%s)', this.status, this.statusText)
        }
      }
    }
  }

}
